<template>
  <Layout :linksData="linksData">
    <v-row class="leads-managements w-100">
      <v-col>
        <h2>
          <span style="color: #237276">{{ store?.getTotalItems }}</span> {{ $t("leads") }}
        </h2>
      </v-col>
      <v-col style="display: flex; justify-content: end">
        <Top :type="'lead'" :leads="leads" />
      </v-col>
    </v-row>
    <FilterSection @openleed="cleed = true" />
    <div class="table">
      <DataTable :leads="leads" />
    </div>
    <!-- <CreateLeedForm v-if="cleed" /> -->
  </Layout>
</template>
<script>
import Layout from "@/components/crm/layouts/Layout.vue";
import activityLogIcon from "@/assets/images/icons/activity-log.svg";
import discussionsIcon from "@/assets/images/icons/discussions.svg";
import importIcon from "@/assets/images/icons/import.svg";
import FilterSection from "@/components/crm/leads/Filter.vue";
import Top from "@/components/crm/leads/Top.vue";
import DataTable from "@/components/crm/leads/table.vue";
import { useLeadsStore } from "@/store/crm/useLeadsStore";
// import CreateLeedForm from "@/components/SuperApp/Awareness/StepTree/CreateLeedForm.vue";
export default {
  components: {
    Layout,
    FilterSection,
    Top,
    DataTable,
    // CreateLeedForm
  },

  data() {
    return {
      activityLogIcon,
      discussionsIcon,
      importIcon,
      drawer: true,
      cleed: false,
      linksData: [
        { name: "home", link: "/home-page" },
        { name: "LeadsManagement", link: "" },
      ],
      store: useLeadsStore(),
    };
  },
  computed: {
    leads() {
      return this.store?.getLeads;
    },
  },
  mounted() {
    this.headers = this.store.headers;
    if (this.store?.getLeads.length === 0) {
      this.store?.getAllLeads();
    }
  },
};
</script>
<style scoped>
.outlinedut {
  border: 1px solid #47898c !important;
  background-color: transparent;
  box-shadow: none;
  /* Ensure the border is visible */
  color: #47898c !important;
  margin-right: 0rem;
}
</style>
